<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item>待回货管理</el-breadcrumb-item>
      </el-breadcrumb>
      <operation-help namespace="stock" help-key="pending-list" :context="{ template, completionMode }" />
    </template>

    <el-form :model="query" ref="query" label-width="90px" class="search-form">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col style="width: 160px">
            <el-input v-model="query.keyword" @keyup.enter="fetchs" prefix-icon="Search"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="流程类型">
          <el-select v-model="template" placeholder="全部类型" clearable @change="fetchs" style="width: 150px">
            <el-option label="维修" value="repair"></el-option>
            <el-option label="融金" value="gold"></el-option>
            <el-option label="送料加工" value="tolling"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结案方式">
          <el-select v-model="completionMode" placeholder="全部方式" clearable @change="fetchs" style="width: 150px">
            <el-option label="回货入库" value="return"></el-option>
            <el-option label="回款结案" value="cash"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showOrgFilters" label="所属公司">
          <el-tree-select ref="companys" v-model="companyId" :data="companys" @change="fetchs()"
            check-strictly :render-after-expand="false" style="min-width: 210px;" />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="单据时间">
          <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
            unlink-panels :shortcuts="$util.getShortCuts()" @change="fetchs()" style="max-width:210px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="单据状态" prop="status">
          <el-select v-model="status" placeholder="请选择单据状态" @change="fetchs" clearable style="width: 180px">
            <el-option label="待负责人审核" value="0"></el-option>
            <el-option label="待回货录入" value="2"></el-option>
            <el-option label="待复核" value="11"></el-option>
            <el-option label="待库管审核" value="21"></el-option>
            <el-option label="已完成" value="1"></el-option>
            <el-option label="已取消" value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" label-width="20px">
          <el-button type="primary" icon="Search" @click="fetchs()">搜索</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="primary" icon="Plus" @click="openDetail('repair')">新增维修出库待回货</el-button>
      <el-button type="primary" icon="Money" plain @click="openDetail('gold')">新增融金出库待回货</el-button>
      <el-button type="success" icon="Tools" plain @click="openDetail('tolling')">新增送料加工待回货</el-button>
      <el-button type="primary" icon="Download" plain @click="exportDialogVisible = true">导出回货明细</el-button>
    </div>

    <el-dialog v-model="exportDialogVisible" title="导出回货明细" width="520px" destroy-on-close>
      <el-radio-group v-model="exportType" class="export-type-list">
        <el-radio v-for="item in exportTypes" :key="item.value" :label="item.value" class="export-type-item">
          <span class="export-type-label">{{ item.label }}</span>
          <span class="export-type-description">{{ item.description }}</span>
        </el-radio>
      </el-radio-group>
      <template #footer>
        <el-button @click="exportDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="exportLoading" @click="exportDetails">确认导出</el-button>
      </template>
    </el-dialog>

    <basic-table ref="table" class="table" :query="query" @handler="fetchs">
      <template v-slot:companyId="scope">
        <span>{{ companyName(scope.row.companyId || scope.row.companyID) }}</span>
      </template>
      <template v-slot:billSource="scope">
        <el-tag size="small" :type="sourceTemplate(scope.row.billSource) == 'gold' ? 'warning' : ''">
          {{ sourceText(scope.row.billSource) }}
        </el-tag>
      </template>
      <template v-slot:status="scope">
        <el-link :type="statusType(scope.row.status)" size="small" disabled>{{ statusText(scope.row.status, scope.row.billSource) }}</el-link>
      </template>
      <template v-slot:tollingProgress="scope">
        <span v-if="sourceTemplate(scope.row.billSource) == 'tolling'">{{ scope.row.tollingProgressText || '-' }}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:tollingInboundState="scope">
        <el-tag v-if="sourceTemplate(scope.row.billSource) == 'tolling' && scope.row.tollingInboundState" size="small"
          :type="scope.row.tollingInboundState == '已正式入库' ? 'success' : 'info'">{{ scope.row.tollingInboundState }}</el-tag>
        <span v-else>-</span>
      </template>
      <template v-slot:toolbar="scope">
        <el-link @click="openDetail(sourceTemplate(scope.row.billSource), scope.row)" type="primary" size="small" style="margin:5px;">
          {{ scope.row.status == 1 || scope.row.status == -1 ? '查看' : '去处理' }}
        </el-link>
        <el-link v-if="scope.row.status == 1" @click="openBillDetail(scope.row)" type="success" size="small"
          style="margin:5px;">库存明细</el-link>
        <el-link v-if="canCancelRow(scope.row)" @click="cancelApplication(scope.row)" type="danger" size="small"
          style="margin:5px;">取消</el-link>
      </template>
    </basic-table>
  </el-card>
</template>

<script>
import BasicTable from "@/components/basic-table.vue";
import { exportPendingReturn, cancelPendingReturn, fetchPendingReturnDetail } from "@/api/stock";

export default {
  name: "StockBills",
  components: { BasicTable },
  data() {
    return {
      dateRange: [],
      status: "",
      template: "",
      completionMode: "",
      exportDialogVisible: false,
      exportLoading: false,
      exportType: "repair-out",
      exportTypes: [
        { value: "repair-out", label: "维修出库货品", description: "维修出库需要回货；原货品维修后进行回货，并标记是否已回货。" },
        { value: "repair-return", label: "维修回货货品", description: "导出已完成正式维修入库的回货货品。" },
        { value: "gold-out", label: "融金出库货品", description: "融金出库无回货要求。" },
        { value: "tolling-out", label: "送料加工出库", description: "导出送料加工正式出库的半成品及加工商、计划进度。" },
        { value: "tolling-return", label: "送料加工回货", description: "导出已完成正式入库的送料加工成品。" },
        { value: "tolling-variance", label: "送料加工差异", description: "导出少回、多回或非计划成品的差异结案记录。" }
      ],
      companys: [],
      companyId: "",
      query: {
        keyword: "",
        columns: [
          { type: "selection", width: "55" },
          { type: "index", label: "序号" },
          { prop: "billType", label: "单据类型", sortable: true, searchable: true, width: "110", showOverflowTooltip: true },
          { type: "template", prop: "billSource", label: "流程", sortable: true, searchable: true, width: "110", showOverflowTooltip: true },
          { prop: "billCode", label: "单据编号", sortable: true, searchable: true, width: "150", showOverflowTooltip: true },
          { type: "template", prop: "companyId", label: "公司", sortable: true, searchable: true, width: "130", showOverflowTooltip: true },
          { prop: "netCode", label: "关联单号", sortable: true, searchable: true, width: "130", showOverflowTooltip: true },
          { prop: "productNumber", label: "数量", width: "60" },
          { type: "template", prop: "tollingProgress", label: "计划/已回/待回", width: "135" },
          { type: "template", prop: "tollingInboundState", label: "送料入库状态", width: "145" },
          { prop: "costTotal", label: "金额", sortable: true, width: "90" },
          { prop: "billDate", label: "单据时间", width: "140", sortable: true, showOverflowTooltip: true },
          { type: "template", prop: "status", label: "状态", width: "110", searchable: true },
          { prop: "operatorName", label: "申请人", sortable: true, searchable: true, width: "80" },
          { prop: "handoverName", label: "负责人", searchable: true, width: "80" },
          { prop: "reviewerName", label: "复核", searchable: true, width: "80" },
          { prop: "financerName", label: "财务", searchable: true, width: "80" },
          { prop: "reason", label: "备注", searchable: true, width: "220", showOverflowTooltip: true },
          { prop: "createDate", label: "创建时间", width: "150", sortable: true, showOverflowTooltip: true },
          { prop: "createUserName", label: "创建人", sortable: true, searchable: true, width: "90" },
          { type: "toolbar", label: "操作", width: "150" },
        ],
        filters: [],
        sidx: "billDate",
        sord: "desc"
      }
    };
  },
  mounted() {
    this.template = this.defaultTemplate();
    this.$kaung.init(this.$options.name);
    this.$kaung.initCompanys(this, this.fetchs);
  },
  methods: {
    defaultTemplate() {
      if (this.$route.query.template) return this.$route.query.template;
      if (this.$route.path.indexOf("/repair") >= 0) return "repair";
      if (this.$route.path.indexOf("/gold") >= 0) return "gold";
      if (this.$route.path.indexOf("/tolling") >= 0) return "tolling";
      return "";
    },
    fetchs() {
      this.query.filters = [{ name: "billType", value: "待回货流程", operate: 0 }];
      if (this.template && this.completionMode) {
        this.query.filters.push({ name: "billSource", value: this.template + ":" + this.completionMode, operate: 0 });
      } else if (this.template) {
        this.query.filters.push({ name: "billSource", value: this.template + ":return," + this.template + ":cash", operate: 6 });
      } else if (this.completionMode) {
        this.query.filters.push({ name: "billSource", value: "repair:" + this.completionMode + ",gold:" + this.completionMode + ",tolling:" + this.completionMode, operate: 6 });
      }
      if (this.dateRange && this.dateRange[0]) {
        this.query.filters.push({ name: "billDate", value: this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd"), operate: 2 });
      }
      if (this.dateRange && this.dateRange[1]) {
        this.query.filters.push({ name: "billDate", value: this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59", operate: 4 });
      }
      if (this.showOrgFilters) {
        if (!this.companyId || this.companyId.length == 0) {
          this.companyId = this.$store.getters.getUserInfo?.companyID || "";
        }
        if (this.companyId && this.companyId.length > 0) {
          this.query.filters.push({ name: "companyId", value: this.companyId, operate: 6 });
        }
      }
      if (this.status) {
        this.query.filters.push({ name: "status", value: this.status, operate: 0 });
      }
      let { data, records, total, ...params } = { ...this.query };
      this.$kaung.search(params).then((res) => {
        this.query = { ...res.data };
        const rows = this.query.data || [];
        const tasks = rows
          .filter(row => this.sourceTemplate(row.billSource) == "tolling")
          .map(row => fetchPendingReturnDetail(row.id).then(detailRes => {
            const progress = detailRes.data?.tollingProgress || {};
            row.tollingProgressText = `${Number(progress.plannedQuantity || 0)}/${Number(progress.actualQuantity || 0)}/${Number(progress.pendingQuantity || 0)}`;
            row.tollingInboundState = detailRes.data?.inboundState || "未转入库";
          }).catch(() => { row.tollingProgressText = "-"; }));
        if (tasks.length > 0) {
          Promise.all(tasks).then(() => { this.query = { ...this.query, data: [...rows] }; });
        }
      });
    },
    openDetail(template, row) {
      this.$router.push({ path: "/stock/bills/pendingReturnDetail", query: { id: row?.id || "", template: template || this.template || "repair" } });
    },
    openBillDetail(row) {
      this.$router.push({ path: "/stock/bills/detail", query: { billCode: row.billCode } });
    },
    cancelApplication(row) {
      this.$prompt("取消后申请不可恢复，请填写取消原因。", "取消申请", {
        confirmButtonText: "确认取消",
        cancelButtonText: "返回",
        inputType: "textarea",
        inputPattern: /\S+/,
        inputErrorMessage: "取消原因不能为空",
        type: "warning"
      }).then(({ value }) => {
        cancelPendingReturn(row.id, { reason: (value || "").trim() })
          .then((res) => {
            this.$notify({
              title: res.code == 200 ? "操作成功" : "操作失败",
              message: res.content,
              type: res.code == 200 ? "success" : "error",
              duration: 10000
            });
            if (res.code == 200) this.fetchs();
          });
      }).catch(() => {});
    },
    canCancelRow(row) {
      const code = row?.billCode || "";
      if (code.endsWith("-R")) return false; // 自动生成的待回货单不可取消
      return [0, 11, 21].includes(Number(row?.status));
    },
    exportDetails() {
      const params = {
        ExportType: this.exportType,
        Keyword: this.query.keyword || "",
        CompanyID: this.companyId || (this.showOrgFilters ? (this.$store.getters.getUserInfo?.companyID || "") : ""),
        Status: this.status || "",
        StartDate: this.dateRange && this.dateRange[0] ? this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd") : null,
        EndDate: this.dateRange && this.dateRange[1] ? this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59" : null
      };
      this.exportLoading = true;
      exportPendingReturn(params).then((res) => {
        this.$notify({ title: "导出成功", message: res.content, type: "success", duration: 10000 });
        this.exportDialogVisible = false;
        window.location.href = process.env.VUE_APP_BASEURL + res.data;
      }).catch((error) => {
        if (error?.content == "未查询到数据") {
          this.$message.warning("当前筛选条件下暂无可导出的数据，请调整筛选条件后重试");
          return;
        }
        this.$message.error(error?.content || error?.message || "导出失败");
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    sourceTemplate(value) {
      return (value || "").split(":")[0] || "repair";
    },
    sourceMode(value) {
      return (value || "").split(":")[1] || (this.sourceTemplate(value) == "gold" ? "cash" : "return");
    },
    sourceText(value) {
      const template = this.sourceTemplate(value);
      const templateText = template == "gold" ? "融金" : (template == "tolling" ? "送料加工" : "维修");
      const modeText = this.sourceMode(value) == "cash" ? "回款" : "回货";
      return templateText + "/" + modeText;
    },
    statusText(status, source) {
      const reviewText = this.sourceTemplate(source) == "gold" ? "待财务复核" : "待成本复核";
      const map = { 0: "待负责人审核", 2: "待回货录入", 11: reviewText, 21: "待库管审核", 1: "已完成", "-1": "已取消" };
      return map[status] || "其他";
    },
    statusType(status) {
      const map = { 0: "primary", 2: "info", 11: "warning", 21: "warning", 1: "success", "-1": "danger" };
      return map[status] || "info";
    },
    companyName(companyId) {
      const match = this.findCompany(companyId, this.companys);
      return match?.label || match?.companyName || match?.name || companyId || "";
    },
    findCompany(companyId, list) {
      if (!companyId || !Array.isArray(list)) return null;
      for (const item of list) {
        if (item.id == companyId || item.value == companyId) return item;
        const child = this.findCompany(companyId, item.children);
        if (child) return child;
      }
      return null;
    }
  },
  watch: {
    "$route.path"() {
      this.status = "";
      this.template = this.defaultTemplate();
      this.fetchs();
    },
    "$route.query.template"() {
      this.template = this.defaultTemplate();
      this.fetchs();
    },
    companyId(newValue, oldValue) {
      if (newValue && newValue != oldValue) {
        this.$util.setLocalstorage("companyIdStr", newValue);
      } else {
        this.$util.setLocalstorage("companyIdStr", "");
      }
    }
  }
};
</script>

<style scoped>
.export-type-list {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
}

.export-type-item {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  margin-right: 0;
  text-align: left;
  white-space: normal;
}

:deep(.export-type-item .el-radio__input) {
  margin-top: 3px;
}

:deep(.export-type-item .el-radio__label) {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.export-type-label,
.export-type-description {
  display: block;
}

.export-type-label {
  font-weight: 600;
}

.export-type-description {
  margin-top: 5px;
  color: var(--el-text-color-secondary);
  line-height: 1.5;
}
</style>
